<!-- 续费充值 -->
<template>
  <el-dialog
    :visible.sync="dialogShow"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleClose"
    top="10vh"
    class="device-recharge_dialog"
    append-to-body
    destroy-on-close
  >
    <template #title>
      设备充值
    </template>

    <template #default>
      <!-- 创建订单 -->
      <div v-show="step === 'createorder'" class="item-step">
        <p class="title">
          <label>设备列表[共{{ gatewayList.length }}台]</label>
          <label :style="{ float: 'right' }">下单时间：{{ new Date() | dateFilter('yyyy-MM-dd hh:mm:ss') }}</label>
        </p>
        <el-table
          :data="gatewayList"
          class="gateway-table"
          size="small"
          height="300px"
          :header-row-style="{ background: 'transparent' }"
          :row-style="{ background: 'transparent' }"
          :cell-style="{ background: 'transparent' }"
        >
          <el-table-column label="电站名称" prop="orgname" align="center" />
          <el-table-column label="采集器编号" align="center" prop="gatewaysn" />
          <el-table-column label="产品类型" prop="ptype" align="center" />
          <el-table-column label="设备到期时间" align="center">
            <template #default="{ row }">
              <el-link v-if="row.expiretime" :underline="false" type="danger">
                {{ row.expiretime | dateFilter('yyyy-MM-dd') }}
              </el-link>
            </template>
          </el-table-column>
        </el-table>
        <p class="title">充值套餐</p>
        <div class="price-container">
          <el-radio-group v-model="rechargePriceId" size="small" @change="priceManager().priceChoseCall()">
            <el-radio v-for="(item, index) in priceList" :key="index" :label="item.id" border>
              {{ formatterDuration(item.duration) }} / ￥{{ (item.price - item.preferential).toFixed(2) }} / {{
                $t('text.card') }}</el-radio>
          </el-radio-group>
        </div>
      </div>

      <!-- 支付订单 -->
      <div v-show="step === 'payorder'" class="item-step">
        <p class="p-descript">
          <span>{{ $t('text.amountpayable') }}: ￥{{ totalprice }}</span>
        </p>
        <p class="p-descript">
          {{ $t('text.rmainingpaymenttime') }}<span>{{ payManager.orderCountdownString }}，{{
            $t('text.ordercancelledalert') }}</span>
        </p>
        <div
          v-loading="createOrderIng"
          :style="{ height: '155px', width: '152px', margin: '5px auto' }"
          :element-loading-text="$t('text.generatingorder')"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
        >
          <iframe
            v-if="iframeQrcode"
            :srcdoc="iframeQrcode"
            :style="{ height: '155px', width: '152px' }"
            @load="orderManager().orderLoaded()"
          />
        </div>
        <p class="p-descript">
          <span>{{ $t('text.onlyalipay') }}</span>
        </p>
        <p class="p-descript">
          <img src="../../../assets/icon/zfb.png" alt="">
        </p>
      </div>

      <!-- 支付成功 -->
      <div v-show="step === 'paysuccess'" class="item-step">
        <el-result icon="success">
          <template #title>
            <p class="p-descript">{{ $t('text.paymentsucceeded') }}</p>
          </template>
          <template #subTitle>
            <p class="p-descript">{{ $t('text.paymentsucceedednotify') }}</p>
          </template>
          <template #extra>
            <el-button
              type="primary"
              class="btn_primary"
              size="medium"
              @click="() => {
                handleClose();
                $emit('paysuccess')
              }"
            >{{ $t('button.qd') }}</el-button>
          </template>
        </el-result>
      </div>

      <!-- 订单过期 -->
      <div v-show="step === 'orderexpire'" class="item-step">
        <el-result icon="warning">
          <template #title>
            <p class="p-descript">{{ $t('text.orderexpirednotify') }}</p>
          </template>
          <template #extra>
            <el-button
              type="primary"
              class="btn_primary"
              size="medium"
              @click="() => {
                handleClose();
                $emit('orderexpire')
              }"
            >{{ $t('button.qd') }}</el-button>
          </template>
        </el-result>
      </div>
    </template>
    <template #footer>
      <el-button
        v-show="step === 'createorder'"
        :loading="createOrderIng"
        type="primary"
        class="btn_primary"
        @click="orderManager().createOrder()"
      >{{ $t('text.pay') }}￥{{ totalprice }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { DevicePriceList } from '@/api/Payment/actions'
import { Message } from 'element-ui'
import Paymanager from '@/utils/paymanager'
export default {
  name: 'DeviceRechargeDialog',
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
    gatewayList: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      /** 步骤 */
      step: 'createorder',
      /** 总价/应支付金额 */
      totalprice: 0,
      /** 套餐列表 */
      priceList: [],
      /** 套餐主键 */
      rechargePriceId: '',
      /** 是否创建订单中 */
      createOrderIng: false,
      /** 支付宝订单二维码 */
      iframeQrcode: '',
      /** 支付管理 */
      payManager: null,
      /** 模态框关闭倒计时 */
      dialogCloseCountDown: 3
    }
  },
  created () {
    this.initPayManager()
    this.priceManager().rechargeList()
  },
  methods: {

    /** 初始化支付管理 */
    initPayManager () {
      const options = {
        userid: this.$store.getters.id,
        paySuccessCall: () => {
          this.orderManager().paySuccessCall()
        },
        orderExpireCall: () => {
          this.orderManager().orderExpireCall()
        },
      }
      this.payManager = new Paymanager(options)
    },

    /**
     * 格式化年月日显示
     * @param {number} duration 时长
     */
    formatterDuration (duration) {
      return `${Math.floor(duration / 12)}年`
    },

    /** 套餐管理 */
    priceManager () {
      return {
        /** 获取套餐列表 */
        rechargeList: () => {
          DevicePriceList().then(res => {
            this.priceList = res.data || []
          })
        },

        /** 套餐选择回调 */
        priceChoseCall: () => {
          const priceIndex = this.priceList.findIndex(item => item.id === this.rechargePriceId)
          const priceData = this.priceList[priceIndex]
          this.totalprice = (priceData.price - priceData.preferential) * this.gatewayList.length
        },
      }
    },

    /** 订单管理 */
    orderManager () {
      const component = this
      return {

        /** 创建订单前的校验 */
        orderFormCheck: () => {
          const result = {
            checkResultSuccess: true,
            orderForm: {
              payOrderTitle: "",
              payTotalAmount: 0,
              devicenumberlist: [],
              rechargePriceId: ""
            }
          }
          if (!component.rechargePriceId) {
            this.$message({
              type: 'warning',
              message: '请选择充值套餐',
              duration: 1 * 1000
            })
            result.checkResultSuccess = false
          } else if (component.gatewayList.length === 0) {
            this.$message({
              type: 'warning',
              message: '请勾选要充值的设备',
              duration: 1 * 1000
            })
            result.checkResultSuccess = false
          } else {
            result.orderForm.payOrderTitle = '设备充值'
            result.orderForm.payTotalAmount = this.totalprice
            result.orderForm.devicenumberlist = this.gatewayList.map(item => item.gatewaysn)
            result.orderForm.rechargePriceId = this.rechargePriceId
          }
          return result
        },

        /** 创建订单 */
        createOrder () {
          const checkOrder = this.orderFormCheck()
          if (checkOrder.checkResultSuccess) {
            component.createOrderIng = true
            component.payManager.deviceRecharge(checkOrder.orderForm).then(iframeQrCode => {
              this.createOrderCall(iframeQrCode)
            }).catch(error => {
              Message.error(error)
              component.createOrderIng = false
            })
          }
        },

        /** 创建订单回调 */
        createOrderCall: (iframeQrCode) => {
          this.step = 'payorder'
          this.iframeQrcode = iframeQrCode
        },

        /** 订单加载完成 */
        orderLoaded: () => {
          this.createOrderIng = false
        },

        /** 订单支付成功 */
        paySuccessCall: () => {
          this.step = 'paysuccess'
          this.payManager.clearOrderPay()
          this.iframeQrcode = ''
        },

        /** 订单过期 */
        orderExpireCall: () => {
          this.step = 'orderexpire'
          this.payManager.clearOrderPay()
          this.iframeQrcode = ''
        }
      }
    },

    /** 模态框关闭回调 */
    handleClose () {
      this.payManager.clearOrderPay()
      this.iframeQrcode = ''
      this.step = 'createorder'
      this.$emit('update:dialogShow', false)
    },
  }
}
</script>
<style lang="stylus" scoped>
  .device-recharge_dialog
    .gateway-table
      border: none
      margin: 15px 0
      background-color: #1d3666
    .price-container
      margin: 15px 0
    .item-step
      .title
        border-left: 3px solid #1cc197;
        height: 15px;
        line-height: 15px;
        padding-left: 5px;
        color: #1cc197
      .p-descript
        text-align: center
        color: #1cc197
    .btn_primary
      background-color: #4fce6e
      border-color: #4fce6e
</style>

<style lang="stylus">
  .device-recharge_dialog
    .el-dialog__header
      color: #1cc197
      border-bottom: thin solid #1cc197
    .el-dialog__body
      padding: 20px
    .gateway-table
      th
        background: transparent
        border-color: #1cc197 !important
        color: #1cc197
      td
        border-color: #1cc197
        .cell
          color: #1cc197
      &::before
        background: transparent
    .price-container
      .el-radio
        border-color: #4fce6e
        margin: 5px 10px;
        width: 135px;
        .el-radio__inner
          display: none
        .el-radio__label
          font-weight: 600
          color: #4fce6e
      .is-checked
        background: #4fce6e
        border-color: #4fce6e
        .el-radio__label
          color: #ffffff
</style>

